(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 14);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rerender", function() { return rerender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
/** Virtual DOM Node */
function VNode() {}

/** Global options
 *	@public
 *	@namespace options {Object}
 */
var options = {

	/** If `true`, `prop` changes trigger synchronous component updates.
  *	@name syncComponentUpdates
  *	@type Boolean
  *	@default true
  */
	//syncComponentUpdates: true,

	/** Processes all created VNodes.
  *	@param {VNode} vnode	A newly-created VNode to normalize/process
  */
	//vnode(vnode) { }

	/** Hook invoked after a component is mounted. */
	// afterMount(component) { }

	/** Hook invoked after the DOM is updated with a component's latest render. */
	// afterUpdate(component) { }

	/** Hook invoked immediately before a component is unmounted. */
	// beforeUnmount(component) { }
};

var stack = [];

var EMPTY_CHILDREN = [];

/** JSX/hyperscript reviver
*	Benchmarks: https://esbench.com/bench/57ee8f8e330ab09900a1a1a0
 *	@see http://jasonformat.com/wtf-is-jsx
 *	@public
 */
function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	// if a "vnode hook" is defined, pass every created VNode to it
	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

/** Copy own-properties from `props` onto `obj`.
 *	@returns obj
 *	@private
 */
function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

/** Call a function asynchronously, as soon as possible.
 *	@param {Function} callback
 */
var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
	return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

// DOM properties that should NOT have "px" added when numeric
var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

/** Managed queue of dirty components to be re-rendered */

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p,
	    list = items;
	items = [];
	while (p = list.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

/** Check if two nodes are equivalent.
 *	@param {Element} node
 *	@param {VNode} vnode
 *	@private
 */
function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

/** Check if an Element has a given normalized name.
*	@param {Element} node
*	@param {String} nodeName
 */
function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

/**
 * Reconstruct Component-style `props` from a VNode.
 * Ensures default/fallback values from `defaultProps`:
 * Own-properties of `defaultProps` not present in `vnode.attributes` are added.
 * @param {VNode} vnode
 * @returns {Object} props
 */
function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

/** Create an element with the given nodeName.
 *	@param {String} nodeName
 *	@param {Boolean} [isSvg=false]	If `true`, creates an element within the SVG namespace.
 *	@returns {Element} node
 */
function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

/** Remove a child node from its parent if attached.
 *	@param {Element} node		The node to remove
 */
function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

/** Set a named attribute on the given Node, with special behavior for some names and event handlers.
 *	If `value` is `null`, the attribute/handler will be removed.
 *	@param {Element} node	An element to mutate
 *	@param {string} name	The name/key to set, such as an event or attribute name
 *	@param {any} old	The last value that was set for this name/node pair
 *	@param {any} value	An attribute value, such as a function to be used as an event handler
 *	@param {Boolean} isSvg	Are we currently diffing inside an svg?
 *	@private
 */
function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {
		// ignore
	} else if (name === 'ref') {
		if (old) old(null);
		if (value) value(node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		setProperty(node, name, value == null ? '' : value);
		if (value == null || value === false) node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink\:?/, ''));
		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

/** Attempt to set a DOM property to the given value.
 *	IE & FF throw for certain property-value combinations.
 */
function setProperty(node, name, value) {
	try {
		node[name] = value;
	} catch (e) {}
}

/** Proxy an event to hooked event handlers
 *	@private
 */
function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

/** Queue of components that have been mounted and are awaiting componentDidMount */
var mounts = [];

/** Diff recursion count, used to track the end of the diff cycle. */
var diffLevel = 0;

/** Global flag indicating if the diff is currently within an SVG */
var isSvgMode = false;

/** Global flag indicating if the diff is performing hydration */
var hydrating = false;

/** Invoke queued componentDidMount lifecycle methods */
function flushMounts() {
	var c;
	while (c = mounts.pop()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

/** Apply differences in a given vnode (and it's deep children) to a real DOM Node.
 *	@param {Element} [dom=null]		A DOM node to mutate into the shape of the `vnode`
 *	@param {VNode} vnode			A VNode (with descendants forming a tree) representing the desired DOM structure
 *	@returns {Element} dom			The created/mutated element
 *	@private
 */
function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	// diffLevel having been 0 here indicates initial entry into the diff (not a subdiff)
	if (!diffLevel++) {
		// when first starting the diff, check if we're diffing an SVG or within an SVG
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		// hydration is indicated by the existing element to be diffed not having a prop cache
		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	// append the element if its a new parent
	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	// diffLevel being reduced to 0 means we're exiting the diff
	if (! --diffLevel) {
		hydrating = false;
		// invoke queued componentDidMount lifecycle methods
		if (!componentRoot) flushMounts();
	}

	return ret;
}

/** Internals of `diff()`, separated to allow bypassing diffLevel / mount flushing. */
function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	// empty values (null, undefined, booleans) render as empty Text nodes
	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	// Fast case: Strings & Numbers create/update Text nodes.
	if (typeof vnode === 'string' || typeof vnode === 'number') {

		// update if it's already a Text node:
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			/* istanbul ignore if */ /* Browser quirk that can't be covered: https://github.com/developit/preact/commit/fd4f21f5c45dfd75151bd27b4c217d8003aa5eb9 */
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			// it wasn't a Text node: replace it with one and recycle the old Element
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	// If the VNode represents a Component, perform a component diff:
	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	// Tracks entering and exiting SVG namespace when descending through the tree.
	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	// If there's no existing element or it's the wrong type, create a new one:
	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			// move children into the replacement node
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			} // if the previous Element was mounted into the DOM, replace it inline
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			// recycle the old element (skips non-Element node types)
			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	// Optimization: fast-path for elements containing a single TextNode:
	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	}
	// otherwise, if there are existing or new children, diff them:
	else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	// Apply attributes/props from VNode to the DOM Element:
	diffAttributes(out, vnode.attributes, props);

	// restore previous SVG mode: (in case we're exiting an SVG namespace)
	isSvgMode = prevSvgMode;

	return out;
}

/** Apply child and attribute changes between a VNode and a DOM Node to the DOM.
 *	@param {Element} dom			Element whose children should be compared & mutated
 *	@param {Array} vchildren		Array of VNodes to compare to `dom.childNodes`
 *	@param {Object} context			Implicitly descendant context object (from most recent `getChildContext()`)
 *	@param {Boolean} mountAll
 *	@param {Boolean} isHydrating	If `true`, consumes externally created elements similar to hydration
 */
function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	// Build up a map of keyed children and an Array of unkeyed children:
	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			// attempt to find a node based on key matching
			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			}
			// attempt to pluck a node of the same type from the existing children
			else if (!child && min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			// morph the matched/found/created DOM child to match vchild (deep)
			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	// remove unused keyed children:
	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	// remove orphaned unkeyed children:
	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

/** Recursively recycle (or just unmount) a node and its descendants.
 *	@param {Node} node						DOM node to start unmount/removal from
 *	@param {Boolean} [unmountOnly=false]	If `true`, only triggers unmount lifecycle, skips removal
 */
function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		// if node is owned by a Component, unmount that component (ends up recursing back here)
		unmountComponent(component);
	} else {
		// If the node's VNode had a ref function, invoke it with null here.
		// (this is part of the React spec, and smart for unsetting references)
		if (node['__preactattr_'] != null && node['__preactattr_'].ref) node['__preactattr_'].ref(null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

/** Recollect/unmount all children.
 *	- we use .lastChild here because it causes less reflow than .firstChild
 *	- it's also cheaper than accessing the .childNodes Live NodeList
 */
function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

/** Apply differences in attributes from a VNode to the given DOM Element.
 *	@param {Element} dom		Element with attributes to diff `attrs` against
 *	@param {Object} attrs		The desired end-state key-value attribute pairs
 *	@param {Object} old			Current/previous attributes (from previous VNode or element's prop cache)
 */
function diffAttributes(dom, attrs, old) {
	var name;

	// remove attributes no longer present on the vnode by setting them to undefined
	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	// add new & update changed attributes
	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

/** Retains a pool of Components for re-use, keyed on component name.
 *	Note: since component names are not unique or even necessarily available, these are primarily a form of sharding.
 *	@private
 */
var components = {};

/** Reclaim a component for later re-use by the recycler. */
function collectComponent(component) {
	var name = component.constructor.name;
	(components[name] || (components[name] = [])).push(component);
}

/** Create a component. Normalizes differences between PFC's and classful Components. */
function createComponent(Ctor, props, context) {
	var list = components[Ctor.name],
	    inst;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	if (list) {
		for (var i = list.length; i--;) {
			if (list[i].constructor === Ctor) {
				inst.nextBase = list[i].nextBase;
				list.splice(i, 1);
				break;
			}
		}
	}
	return inst;
}

/** The `.render()` method for a PFC backing instance. */
function doRender(props, state, context) {
	return this.constructor(props, context);
}

/** Set a component's `props` (generally derived from JSX attributes).
 *	@param {Object} props
 *	@param {Object} [opts]
 *	@param {boolean} [opts.renderSync=false]	If `true` and {@link options.syncComponentUpdates} is `true`, triggers synchronous rendering.
 *	@param {boolean} [opts.render=true]			If `false`, no render will be triggered.
 */
function setComponentProps(component, props, opts, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	if (component.__ref = props.ref) delete props.ref;
	if (component.__key = props.key) delete props.key;

	if (!component.base || mountAll) {
		if (component.componentWillMount) component.componentWillMount();
	} else if (component.componentWillReceiveProps) {
		component.componentWillReceiveProps(props, context);
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (opts !== 0) {
		if (opts === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	if (component.__ref) component.__ref(component);
}

/** Render a Component, triggering necessary lifecycle events and taking High-Order Components into account.
 *	@param {Component} component
 *	@param {Object} [opts]
 *	@param {boolean} [opts.build=false]		If `true`, component will build and store a DOM node if not already associated with one.
 *	@private
 */
function renderComponent(component, opts, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    rendered,
	    inst,
	    cbase;

	// if updating
	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (opts !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		// context to pass to the child, can be updated via (grand-)parent component
		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {
			// set up high order component link

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			// destroy high order component link
			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || opts === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.unshift(component);
	} else if (!skip) {
		// Ensure that pending componentDidMount() hooks of child components
		// are called before the componentDidUpdate() hook in the parent.
		// Note: disabled as it causes duplicate hooks, see https://github.com/developit/preact/issues/750
		// flushMounts();

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, previousContext);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	if (component._renderCallbacks != null) {
		while (component._renderCallbacks.length) {
			component._renderCallbacks.pop().call(component);
		}
	}

	if (!diffLevel && !isChild) flushMounts();
}

/** Apply the Component referenced by a VNode to the DOM.
 *	@param {Element} dom	The DOM node to mutate
 *	@param {VNode} vnode	A Component-referencing VNode
 *	@returns {Element} dom	The created/mutated element
 *	@private
 */
function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;
			// passing dom/oldDom as nextBase will recycle it if unused, so bypass recycling on L229:
			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

/** Remove a component from the DOM and recycle it.
 *	@param {Component} component	The Component instance to unmount
 *	@private
 */
function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	// recursively tear down & recollect high-order component children:
	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] && base['__preactattr_'].ref) base['__preactattr_'].ref(null);

		component.nextBase = base;

		removeNode(base);
		collectComponent(component);

		removeChildren(base);
	}

	if (component.__ref) component.__ref(null);
}

/** Base Component class.
 *	Provides `setState()` and `forceUpdate()`, which trigger rendering.
 *	@public
 *
 *	@example
 *	class MyFoo extends Component {
 *		render(props, state) {
 *			return <div />;
 *		}
 *	}
 */
function Component(props, context) {
	this._dirty = true;

	/** @public
  *	@type {object}
  */
	this.context = context;

	/** @public
  *	@type {object}
  */
	this.props = props;

	/** @public
  *	@type {object}
  */
	this.state = this.state || {};
}

extend(Component.prototype, {

	/** Returns a `boolean` indicating if the component should re-render when receiving the given `props` and `state`.
  *	@param {object} nextProps
  *	@param {object} nextState
  *	@param {object} nextContext
  *	@returns {Boolean} should the component re-render
  *	@name shouldComponentUpdate
  *	@function
  */

	/** Update component state by copying properties from `state` to `this.state`.
  *	@param {object} state		A hash of state properties to update with new values
  *	@param {function} callback	A function to be called once component state is updated
  */
	setState: function setState(state, callback) {
		var s = this.state;
		if (!this.prevState) this.prevState = extend({}, s);
		extend(s, typeof state === 'function' ? state(s, this.props) : state);
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		enqueueRender(this);
	},


	/** Immediately perform a synchronous re-render of the component.
  *	@param {function} callback		A function to be called after component is re-rendered.
  *	@private
  */
	forceUpdate: function forceUpdate(callback) {
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		renderComponent(this, 2);
	},


	/** Accepts `props` and `state`, and returns a new Virtual DOM tree to build.
  *	Virtual DOM is generally constructed via [JSX](http://jasonformat.com/wtf-is-jsx).
  *	@param {object} props		Props (eg: JSX attributes) received from parent element/component
  *	@param {object} state		The component's current state
  *	@param {object} context		Context object (if a parent component has provided context)
  *	@returns VNode
  */
	render: function render() {}
});

/** Render JSX into a `parent` Element.
 *	@param {VNode} vnode		A (JSX) VNode to render
 *	@param {Element} parent		DOM element to render into
 *	@param {Element} [merge]	Attempt to re-use an existing DOM tree rooted at `merge`
 *	@public
 *
 *	@example
 *	// render a div into <body>:
 *	render(<div id="hello">hello!</div>, document.body);
 *
 *	@example
 *	// render a "Thing" component into #foo:
 *	const Thing = ({ name }) => <span>{ name }</span>;
 *	render(<Thing name="one" />, document.querySelector('#foo'));
 */
function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};


/* harmony default export */ __webpack_exports__["default"] = (preact);
//# sourceMappingURL=preact.esm.js.map


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var Separator = function Separator(_ref) {
  var style = _ref.style,
      upClass = _ref.upClass,
      downClass = _ref.downClass;
  return (0, _preact.h)(
    'svg',
    { xmlns: 'http://www.w3.org/2000/svg', version: '1.1', width: '100%', height: '50', viewBox: '0 0 100 100', preserveAspectRatio: 'none', className: 'separator', style: style },
    upClass ? (0, _preact.h)('path', { className: upClass, d: 'M0 0 L0 100 L100 0 Z' }) : '',
    downClass ? (0, _preact.h)('path', { className: downClass, d: 'M0 101 L100 100 L100 0 Z' }) : ''
  );
};

exports.default = Separator;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = {"name":"serverlesslab.com","version":"1.0.16","versionDate":"2017-10-09","description":"Source code for serverlesslab.com website","private":true,"scripts":{"start":"webpack-dev-server --open","build":"webpack -p","test:lint":"node_modules/.bin/eslint src/ webpack.config.js","test":"npm run test:lint","release:tag":"git tag $npm_package_version && git push --tags","deploy":"gh-pages -d build --dotfiles"},"repository":{"type":"git","url":"git+https://github.com/lucpod/serverlesslab.com.git"},"keywords":[],"author":"","license":"ISC","bugs":{"url":"https://github.com/lucpod/serverlesslab.com/issues"},"homepage":"https://github.com/lucpod/serverlesslab.com#readme","devDependencies":{"aos":"^2.2.0","babel-cli":"^6.26.0","babel-core":"^6.26.0","babel-loader":"^7.1.2","babel-plugin-transform-react-jsx":"^6.24.1","babel-preset-es2015":"^6.24.1","bulma":"^0.5.1","clean-webpack-plugin":"^0.1.16","compression-webpack-plugin":"^1.0.0","copy-webpack-plugin":"^4.0.1","css-loader":"^0.28.7","eslint":"^4.6.1","eslint-config-standard":"^10.2.1","eslint-config-standard-react":"^5.0.0","eslint-plugin-import":"^2.7.0","eslint-plugin-node":"^5.1.1","eslint-plugin-promise":"^3.5.0","eslint-plugin-react":"^7.3.0","eslint-plugin-standard":"^3.0.1","extract-text-webpack-plugin":"^3.0.0","file-loader":"^0.11.2","gh-pages":"^1.0.0","json-loader":"^0.5.7","node-sass":"^4.5.3","preact":"^8.2.5","preact-render-to-string":"^3.6.3","sass-loader":"^6.0.6","static-site-generator-webpack-plugin":"^3.4.1","style-loader":"^0.18.2","webpack":"^3.5.6","webpack-dev-server":"^2.7.1"}}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bf96506f468d52bbfbccbdf424ed430f.svg";

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2ccb0d7b9c1788ac1ceff2c502d16e16.jpg";

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */
var drift = function drift() {
  !function () {
    var t;
    if (t = window.driftt = window.drift = window.driftt || [], !t.init) {
      return t.invoked ? void (window.console && console.error && console.error('Drift snippet included twice.')) : (t.invoked = !0, t.methods = ['identify', 'config', 'track', 'reset', 'debug', 'show', 'ping', 'page', 'hide', 'off', 'on'], t.factory = function (e) {
        return function () {
          var n;
          return n = Array.prototype.slice.call(arguments), n.unshift(e), t.push(n), t;
        };
      }, t.methods.forEach(function (e) {
        t[e] = t.factory(e);
      }), t.load = function (t) {
        var e, n, o, i;
        e = 3e5, i = Math.ceil(new Date() / e) * e, o = document.createElement('script'), o.type = 'text/javascript', o.async = !0, o.crossorigin = 'anonymous', o.src = 'https://js.driftt.com/include/' + i + '/' + t + '.js', n = document.getElementsByTagName('script')[0], n.parentNode.insertBefore(o, n);
      });
    }
  }();
  window.drift.SNIPPET_VERSION = '0.3.1';
  window.drift.load('ava57h5bw28g');
};

var openChat = exports.openChat = function openChat(e) {
  if (e && e.preventDefault) {
    e.preventDefault();
  }
  window.drift.api.openChat();
};

exports.default = drift;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _drift = __webpack_require__(5);

var TalkToUsButton = function TalkToUsButton(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === undefined ? 'Talk to us today' : _ref$label;
  return (0, _preact.h)(
    'a',
    { href: '#', onClick: _drift.openChat, className: 'button is-info is-large' },
    label
  );
};

exports.default = TalkToUsButton;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STATE_SCRIPT_ID = '__HTMLDOCUMENT__UNIVERSAL_STATE';
var ASSET_TYPES = {
  STYLESHEET: 'STYLESHEET',
  SCRIPT: 'SCRIPT'
};

var HTMLDocument = function (_Component) {
  _inherits(HTMLDocument, _Component);

  function HTMLDocument() {
    _classCallCheck(this, HTMLDocument);

    return _possibleConstructorReturn(this, (HTMLDocument.__proto__ || Object.getPrototypeOf(HTMLDocument)).apply(this, arguments));
  }

  _createClass(HTMLDocument, [{
    key: 'renderChildren',
    value: function renderChildren() {
      return this.props.children ? this.props.children : null;
    }
  }, {
    key: 'renderLinks',
    value: function renderLinks() {
      var links = this.props.links;

      return links.map(function (data, index) {
        return (0, _preact.h)('link', _extends({ key: index }, data));
      });
    }
  }, {
    key: 'renderFavicon',
    value: function renderFavicon() {
      var favicon = this.props.favicon;

      if (!favicon) return null;
      return (0, _preact.h)('link', { rel: 'icon', href: favicon });
    }
  }, {
    key: 'renderMetatags',
    value: function renderMetatags() {
      var metatags = this.props.metatags;

      return metatags.map(function (props, index) {
        return (0, _preact.h)('meta', _extends({ key: index }, props));
      });
    }
  }, {
    key: 'renderInlineAsset',
    value: function renderInlineAsset(type, html) {
      var innerHTML = { __html: html };
      if (type === ASSET_TYPES.STYLESHEET) {
        return (0, _preact.h)('style', { key: html, dangerouslySetInnerHTML: innerHTML });
      }
      return (0, _preact.h)('script', { key: html, dangerouslySetInnerHTML: innerHTML });
    }
  }, {
    key: 'renderImportedAsset',
    value: function renderImportedAsset(type, props) {
      if (type === ASSET_TYPES.STYLESHEET) {
        return (0, _preact.h)('link', _extends({ key: props.href, rel: 'stylesheet' }, props));
      }
      return (0, _preact.h)('script', _extends({ key: props.src }, props));
    }
  }, {
    key: 'renderAsset',
    value: function renderAsset(type, props) {
      if (props.inline) {
        var html = props.inline;
        return this.renderInlineAsset(type, html);
      }
      return this.renderImportedAsset(type, props);
    }
  }, {
    key: 'renderStylesheets',
    value: function renderStylesheets() {
      var _this2 = this;

      var stylesheets = this.props.stylesheets;

      return stylesheets.map(function (props) {
        var stylesheetProps = typeof props === 'string' ? { href: props } : props;
        return _this2.renderAsset(ASSET_TYPES.STYLESHEET, stylesheetProps);
      });
    }
  }, {
    key: 'renderScripts',
    value: function renderScripts() {
      var _this3 = this;

      var scripts = this.props.scripts;

      return scripts.map(function (props) {
        var scriptProps = typeof props === 'string' ? { src: props } : props;
        return _this3.renderAsset(ASSET_TYPES.SCRIPT, scriptProps);
      });
    }
  }, {
    key: 'renderUniversalStateScript',
    value: function renderUniversalStateScript() {
      if (!this.props.universalState) return null;
      var universalState = this.props.universalState;

      var stringifiedUniversalState = JSON.stringify(universalState);
      var innerHTML = { __html: stringifiedUniversalState };
      return (0, _preact.h)('script', { id: STATE_SCRIPT_ID, type: 'application/json', dangerouslySetInnerHTML: innerHTML });
    }
  }, {
    key: 'render',
    value: function render() {
      return (0, _preact.h)(
        'html',
        this.props.htmlAttributes,
        (0, _preact.h)(
          'head',
          null,
          (0, _preact.h)(
            'title',
            null,
            this.props.title
          ),
          this.renderLinks(),
          this.renderMetatags(),
          this.renderFavicon(),
          this.renderStylesheets()
        ),
        (0, _preact.h)(
          'body',
          null,
          this.renderChildren(),
          this.renderUniversalStateScript(),
          this.renderScripts()
        )
      );
    }
  }]);

  return HTMLDocument;
}(_preact.Component);

HTMLDocument.defaultProps = {
  childrenContainerId: 'app',
  htmlAttributes: {},
  favicon: '',
  metatags: [],
  scripts: [],
  stylesheets: [],
  title: '',
  universalState: null
};

exports.default = HTMLDocument;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _logoColor = __webpack_require__(3);

var _logoColor2 = _interopRequireDefault(_logoColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Menu = function (_Component) {
  _inherits(Menu, _Component);

  function Menu(props) {
    _classCallCheck(this, Menu);

    var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));

    _this.state = {
      burgerActive: false
    };
    _this._burgerClick = _this._burgerClick.bind(_this);
    return _this;
  }

  _createClass(Menu, [{
    key: '_burgerClick',
    value: function _burgerClick() {
      this.setState({ burgerActive: !this.state.burgerActive });
    }
  }, {
    key: 'render',
    value: function render(_ref) {
      var _ref$base = _ref.base,
          base = _ref$base === undefined ? '' : _ref$base;

      return (0, _preact.h)(
        'div',
        { id: 'menu', className: 'mainnav' },
        (0, _preact.h)(
          'div',
          { className: 'container' },
          (0, _preact.h)(
            'nav',
            { className: 'navbar' },
            (0, _preact.h)(
              'div',
              { className: 'navbar-brand' },
              (0, _preact.h)(
                'a',
                { className: 'navbar-item', href: '/' },
                (0, _preact.h)('img', { src: _logoColor2.default, alt: 'Serverless lab - Effective Serverless, AWS Lambda, and Node.js training', width: '112', height: '28' })
              ),
              (0, _preact.h)(
                'div',
                { onClick: this._burgerClick,
                  className: 'navbar-burger ' + (this.state.burgerActive ? 'is-active' : ''),
                  'data-target': 'navMenu-main'
                },
                (0, _preact.h)(
                  'span',
                  null,
                  '\xA0'
                ),
                (0, _preact.h)(
                  'span',
                  null,
                  '\xA0'
                ),
                (0, _preact.h)(
                  'span',
                  null,
                  '\xA0'
                )
              )
            ),
            (0, _preact.h)(
              'div',
              { id: 'navMenu-main', className: 'navbar-menu ' + (this.state.burgerActive ? 'is-active' : '') },
              (0, _preact.h)(
                'div',
                { className: 'navbar-start' },
                (0, _preact.h)(
                  'a',
                  { className: 'navbar-item', href: base + '#value-proposition' },
                  'Our offer'
                ),
                (0, _preact.h)(
                  'a',
                  { className: 'navbar-item', href: base + '#why-serverless' },
                  'Why Serverless?'
                ),
                (0, _preact.h)(
                  'a',
                  { className: 'navbar-item', href: base + '#curricula' },
                  'Curricula'
                ),
                (0, _preact.h)(
                  'a',
                  { className: 'navbar-item', href: base + '#instructors' },
                  'Instructors'
                ),
                (0, _preact.h)(
                  'a',
                  { className: 'navbar-item', href: base + '#why-training' },
                  'ROI'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Menu;
}(_preact.Component);

exports.default = Menu;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _VersionBadge = __webpack_require__(13);

var _VersionBadge2 = _interopRequireDefault(_VersionBadge);

var _logoColor = __webpack_require__(3);

var _logoColor2 = _interopRequireDefault(_logoColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer() {
  return (0, _preact.h)(
    'section',
    { id: 'footer', className: 'section footer' },
    (0, _preact.h)(
      'div',
      { className: 'container' },
      (0, _preact.h)(
        'div',
        { className: 'columns' },
        (0, _preact.h)(
          'div',
          { className: 'column is-three-quarters' },
          (0, _preact.h)(
            'div',
            { className: 'content' },
            (0, _preact.h)(
              'p',
              { className: 'is-size-6' },
              'Copyright \u2014 \xA9 Serverlesslab 2017',
              (0, _preact.h)('br', null),
              (0, _preact.h)(
                'span',
                { className: 'is-size-7' },
                'All rights reserved'
              )
            ),
            (0, _preact.h)(
              'p',
              { className: 'is-size-7' },
              'Cover photo by Igor Ovsyannykov on ',
              (0, _preact.h)(
                'a',
                { href: 'https://unsplash.com/photos/vdWewqfr_V0', target: '_blank' },
                'Unsplash'
              ),
              (0, _preact.h)('br', null),
              'Icons set (Science-icons) by ',
              (0, _preact.h)(
                'a',
                { href: 'https://www.swifticons.com/', target: '_blank' },
                'SwiftIcons'
              ),
              (0, _preact.h)('br', null),
              'Adopting ',
              (0, _preact.h)(
                'a',
                { href: 'https://bulma.io', target: '_blank' },
                'Bulma'
              ),
              ' CSS framework'
            )
          )
        ),
        (0, _preact.h)(
          'div',
          { className: 'column is-one-quarter' },
          (0, _preact.h)(
            'div',
            { className: 'content' },
            (0, _preact.h)(
              'p',
              { className: 'is-size-7 has-text-centered' },
              (0, _preact.h)(
                'a',
                { href: '/', className: 'image' },
                (0, _preact.h)('img', { style: { maxWidth: '300px' }, src: _logoColor2.default, alt: 'Serverless lab - Effective Serverless, AWS Lambda, and Node.js training' })
              )
            ),
            (0, _preact.h)(
              'p',
              { className: 'is-size-7 has-text-centered' },
              'Built with ',
              (0, _preact.h)(
                'strong',
                null,
                '\u2665\uFE0E'
              ),
              ' in ',
              (0, _preact.h)(
                'strong',
                null,
                'Dublin'
              ),
              (0, _preact.h)('br', null),
              'by a ',
              (0, _preact.h)(
                'strong',
                null,
                'Corkonian'
              ),
              ' and a ',
              (0, _preact.h)(
                'strong',
                null,
                'Sicilian'
              )
            ),
            (0, _preact.h)(
              'p',
              { className: 'has-text-centered' },
              (0, _preact.h)(_VersionBadge2.default, null)
            )
          )
        )
      )
    )
  );
};

exports.default = Footer;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
  /* eslint-enable */

  return window.ga;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.AOS=t():e.AOS=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var i=n[o]={exports:{},id:o,loaded:!1};return e[o].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="dist/",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},r=n(1),a=(o(r),n(6)),u=o(a),c=n(7),f=o(c),s=n(8),d=o(s),l=n(9),p=o(l),m=n(10),b=o(m),v=n(11),y=o(v),g=n(14),h=o(g),w=[],k=!1,x=document.all&&!window.atob,j={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,startEvent:"DOMContentLoaded"},O=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e&&(k=!0),k)return w=(0,y.default)(w,j),(0,b.default)(w,j.once),w},S=function(){w=(0,h.default)(),O()},_=function(){w.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay")})},E=function(e){return e===!0||"mobile"===e&&p.default.mobile()||"phone"===e&&p.default.phone()||"tablet"===e&&p.default.tablet()||"function"==typeof e&&e()===!0},z=function(e){return j=i(j,e),w=(0,h.default)(),E(j.disable)||x?_():(document.querySelector("body").setAttribute("data-aos-easing",j.easing),document.querySelector("body").setAttribute("data-aos-duration",j.duration),document.querySelector("body").setAttribute("data-aos-delay",j.delay),"DOMContentLoaded"===j.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1?O(!0):"load"===j.startEvent?window.addEventListener(j.startEvent,function(){O(!0)}):document.addEventListener(j.startEvent,function(){O(!0)}),window.addEventListener("resize",(0,f.default)(O,50,!0)),window.addEventListener("orientationchange",(0,f.default)(O,50,!0)),window.addEventListener("scroll",(0,u.default)(function(){(0,b.default)(w,j.once)},99)),document.addEventListener("DOMNodeRemoved",function(e){var t=e.target;t&&1===t.nodeType&&t.hasAttribute&&t.hasAttribute("data-aos")&&(0,f.default)(S,50,!0)}),(0,d.default)("[data-aos]",S),w)};e.exports={init:z,refresh:O,refreshHard:S}},function(e,t){},,,,,function(e,t){(function(t){"use strict";function n(e,t,n){function o(t){var n=b,o=v;return b=v=void 0,k=t,g=e.apply(o,n)}function r(e){return k=e,h=setTimeout(s,t),S?o(e):g}function a(e){var n=e-w,o=e-k,i=t-n;return _?j(i,y-o):i}function c(e){var n=e-w,o=e-k;return void 0===w||n>=t||n<0||_&&o>=y}function s(){var e=O();return c(e)?d(e):void(h=setTimeout(s,a(e)))}function d(e){return h=void 0,E&&b?o(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),k=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(O())}function m(){var e=O(),n=c(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(_)return h=setTimeout(s,t),o(w)}return void 0===h&&(h=setTimeout(s,t)),g}var b,v,y,g,h,w,k=0,S=!1,_=!1,E=!0;if("function"!=typeof e)throw new TypeError(f);return t=u(t)||0,i(n)&&(S=!!n.leading,_="maxWait"in n,y=_?x(u(n.maxWait)||0,t):y,E="trailing"in n?!!n.trailing:E),m.cancel=l,m.flush=p,m}function o(e,t,o){var r=!0,a=!0;if("function"!=typeof e)throw new TypeError(f);return i(o)&&(r="leading"in o?!!o.leading:r,a="trailing"in o?!!o.trailing:a),n(e,t,{leading:r,maxWait:t,trailing:a})}function i(e){var t="undefined"==typeof e?"undefined":c(e);return!!e&&("object"==t||"function"==t)}function r(e){return!!e&&"object"==("undefined"==typeof e?"undefined":c(e))}function a(e){return"symbol"==("undefined"==typeof e?"undefined":c(e))||r(e)&&k.call(e)==d}function u(e){if("number"==typeof e)return e;if(a(e))return s;if(i(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(l,"");var n=m.test(e);return n||b.test(e)?v(e.slice(2),n?2:8):p.test(e)?s:+e}var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},f="Expected a function",s=NaN,d="[object Symbol]",l=/^\s+|\s+$/g,p=/^[-+]0x[0-9a-f]+$/i,m=/^0b[01]+$/i,b=/^0o[0-7]+$/i,v=parseInt,y="object"==("undefined"==typeof t?"undefined":c(t))&&t&&t.Object===Object&&t,g="object"==("undefined"==typeof self?"undefined":c(self))&&self&&self.Object===Object&&self,h=y||g||Function("return this")(),w=Object.prototype,k=w.toString,x=Math.max,j=Math.min,O=function(){return h.Date.now()};e.exports=o}).call(t,function(){return this}())},function(e,t){(function(t){"use strict";function n(e,t,n){function i(t){var n=b,o=v;return b=v=void 0,O=t,g=e.apply(o,n)}function r(e){return O=e,h=setTimeout(s,t),S?i(e):g}function u(e){var n=e-w,o=e-O,i=t-n;return _?x(i,y-o):i}function f(e){var n=e-w,o=e-O;return void 0===w||n>=t||n<0||_&&o>=y}function s(){var e=j();return f(e)?d(e):void(h=setTimeout(s,u(e)))}function d(e){return h=void 0,E&&b?i(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),O=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(j())}function m(){var e=j(),n=f(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(_)return h=setTimeout(s,t),i(w)}return void 0===h&&(h=setTimeout(s,t)),g}var b,v,y,g,h,w,O=0,S=!1,_=!1,E=!0;if("function"!=typeof e)throw new TypeError(c);return t=a(t)||0,o(n)&&(S=!!n.leading,_="maxWait"in n,y=_?k(a(n.maxWait)||0,t):y,E="trailing"in n?!!n.trailing:E),m.cancel=l,m.flush=p,m}function o(e){var t="undefined"==typeof e?"undefined":u(e);return!!e&&("object"==t||"function"==t)}function i(e){return!!e&&"object"==("undefined"==typeof e?"undefined":u(e))}function r(e){return"symbol"==("undefined"==typeof e?"undefined":u(e))||i(e)&&w.call(e)==s}function a(e){if("number"==typeof e)return e;if(r(e))return f;if(o(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=o(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(d,"");var n=p.test(e);return n||m.test(e)?b(e.slice(2),n?2:8):l.test(e)?f:+e}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c="Expected a function",f=NaN,s="[object Symbol]",d=/^\s+|\s+$/g,l=/^[-+]0x[0-9a-f]+$/i,p=/^0b[01]+$/i,m=/^0o[0-7]+$/i,b=parseInt,v="object"==("undefined"==typeof t?"undefined":u(t))&&t&&t.Object===Object&&t,y="object"==("undefined"==typeof self?"undefined":u(self))&&self&&self.Object===Object&&self,g=v||y||Function("return this")(),h=Object.prototype,w=h.toString,k=Math.max,x=Math.min,j=function(){return g.Date.now()};e.exports=n}).call(t,function(){return this}())},function(e,t){"use strict";function n(e,t){a.push({selector:e,fn:t}),!u&&r&&(u=new r(o),u.observe(i.documentElement,{childList:!0,subtree:!0,removedNodes:!0})),o()}function o(){for(var e,t,n=0,o=a.length;n<o;n++){e=a[n],t=i.querySelectorAll(e.selector);for(var r,u=0,c=t.length;u<c;u++)r=t[u],r.ready||(r.ready=!0,e.fn.call(r,r))}}Object.defineProperty(t,"__esModule",{value:!0});var i=window.document,r=window.MutationObserver||window.WebKitMutationObserver,a=[],u=void 0;t.default=n},function(e,t){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(){return navigator.userAgent||navigator.vendor||window.opera||""}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),r=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,a=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,u=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,c=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,f=function(){function e(){n(this,e)}return i(e,[{key:"phone",value:function(){var e=o();return!(!r.test(e)&&!a.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=o();return!(!u.test(e)&&!c.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}}]),e}();t.default=new f},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e,t,n){var o=e.node.getAttribute("data-aos-once");t>e.position?e.node.classList.add("aos-animate"):"undefined"!=typeof o&&("false"===o||!n&&"true"!==o)&&e.node.classList.remove("aos-animate")},o=function(e,t){var o=window.pageYOffset,i=window.innerHeight;e.forEach(function(e,r){n(e,i+o,t)})};t.default=o},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(12),r=o(i),a=function(e,t){return e.forEach(function(e,n){e.node.classList.add("aos-init"),e.position=(0,r.default)(e.node,t.offset)}),e};t.default=a},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(13),r=o(i),a=function(e,t){var n=0,o=0,i=window.innerHeight,a={offset:e.getAttribute("data-aos-offset"),anchor:e.getAttribute("data-aos-anchor"),anchorPlacement:e.getAttribute("data-aos-anchor-placement")};switch(a.offset&&!isNaN(a.offset)&&(o=parseInt(a.offset)),a.anchor&&document.querySelectorAll(a.anchor)&&(e=document.querySelectorAll(a.anchor)[0]),n=(0,r.default)(e).top,a.anchorPlacement){case"top-bottom":break;case"center-bottom":n+=e.offsetHeight/2;break;case"bottom-bottom":n+=e.offsetHeight;break;case"top-center":n+=i/2;break;case"bottom-center":n+=i/2+e.offsetHeight;break;case"center-center":n+=i/2+e.offsetHeight/2;break;case"top-top":n+=i;break;case"bottom-top":n+=e.offsetHeight+i;break;case"center-top":n+=e.offsetHeight/2+i}return a.anchorPlacement||a.offset||isNaN(t)||(o=t),n+o};t.default=a},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}};t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){e=e||document.querySelectorAll("[data-aos]");var t=[];return[].forEach.call(e,function(e,n){t.push({node:e})}),t};t.default=n}])});
//# sourceMappingURL=aos.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _package = __webpack_require__(2);

var VersionBadge = function VersionBadge() {
  return (0, _preact.h)(
    'a',
    { href: 'https://github.com/lucpod/serverlesslab.com', className: 'versionBadge' },
    (0, _preact.h)(
      'span',
      { className: 'version' },
      'v',
      _package.version
    ),
    (0, _preact.h)(
      'span',
      { className: 'date' },
      _package.versionDate
    )
  );
};

exports.default = VersionBadge;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _package = __webpack_require__(2);

var _preact = __webpack_require__(0);

var _HTMLDocument = __webpack_require__(7);

var _HTMLDocument2 = _interopRequireDefault(_HTMLDocument);

__webpack_require__(8);

var _Menu = __webpack_require__(9);

var _Menu2 = _interopRequireDefault(_Menu);

var _Hero = __webpack_require__(15);

var _Hero2 = _interopRequireDefault(_Hero);

var _ValueProposition = __webpack_require__(17);

var _ValueProposition2 = _interopRequireDefault(_ValueProposition);

var _WhyServerless = __webpack_require__(19);

var _WhyServerless2 = _interopRequireDefault(_WhyServerless);

var _Curricula = __webpack_require__(21);

var _Curricula2 = _interopRequireDefault(_Curricula);

var _Instructors = __webpack_require__(26);

var _Instructors2 = _interopRequireDefault(_Instructors);

var _WhyTraining = __webpack_require__(37);

var _WhyTraining2 = _interopRequireDefault(_WhyTraining);

var _Closing = __webpack_require__(39);

var _Closing2 = _interopRequireDefault(_Closing);

var _Footer = __webpack_require__(10);

var _Footer2 = _interopRequireDefault(_Footer);

var _drift = __webpack_require__(5);

var _drift2 = _interopRequireDefault(_drift);

var _ga = __webpack_require__(11);

var _ga2 = _interopRequireDefault(_ga);

var _aos = __webpack_require__(12);

var _aos2 = _interopRequireDefault(_aos);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Content = function Content() {
  return (0, _preact.h)(
    'div',
    null,
    (0, _preact.h)(_Menu2.default, null),
    (0, _preact.h)(_Hero2.default, null),
    (0, _preact.h)(_ValueProposition2.default, null),
    (0, _preact.h)(_WhyServerless2.default, null),
    (0, _preact.h)(_Curricula2.default, null),
    (0, _preact.h)(_Instructors2.default, null),
    (0, _preact.h)(_WhyTraining2.default, null),
    (0, _preact.h)(_Closing2.default, null),
    (0, _preact.h)(_Footer2.default, null)
  );
};

var Site = function Site(_ref) {
  var assets = _ref.assets;
  return (0, _preact.h)(
    _HTMLDocument2.default,
    {
      title: 'Serverless Lab - Serverless workshops from serverless and AWS experts',
      metatags: [{ charset: 'utf-8' }, { name: 'viewport', content: 'width=device-width, initial-scale=1' }, { name: 'description', content: 'Effective Serverless, AWS Lambda and Node.js training' }, { name: 'theme-color', content: '#ffffff' }, { property: 'og:type', content: 'website' }, { property: 'og:title', content: 'Serverless Lab' }, { property: 'og:description', content: 'Effective Serverless, AWS Lambda and Node.js training' }, { property: 'og:url', content: 'https://serverlesslab.com' }, { property: 'og:image', content: 'https://serverlesslab.com/fb-share.jpg' }, { property: 'fb:app_id', content: '1738463943124904' }, { name: 'twitter:card', content: 'summary_large_image' }, { name: 'twitter:site', content: '@loige' }, { name: 'twitter:creator', content: '@Podgeypoos79' }, { name: 'twitter:title', content: 'Serverless Lab' }, { name: 'twitter:description', content: 'Effective Serverless, AWS Lambda and Node.js training' }, { name: 'twitter:image', content: 'https://serverlesslab.com/tw-share.jpg' }],
      links: [{ rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' }, { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' }, { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' }, { rel: 'manifest', href: '/manifest.json' }, { rel: 'mask-icon', color: '#00386d', href: '/safari-pinned-tab.svg' }],
      stylesheets: ['style-' + _package.version + '.css'],
      scripts: ['' + assets.site]
    },
    (0, _preact.h)(
      'div',
      { id: 'main' },
      (0, _preact.h)(Content, null)
    )
  );
};

// frontend initialization
if (window && document) {
  window.onload = function () {
    var root = document.getElementById('main');
    (0, _preact.render)((0, _preact.h)(Content, { isClient: true }), root, root.firstChild);

    if (window.location.href.indexOf('localhost') === -1) {
      (0, _drift2.default)(); // init drift
      var g = (0, _ga2.default)(); // init google analytics
      g('create', 'UA-106612990-1', 'auto');
      g('send', 'pageview');
    }

    _aos2.default && _aos2.default.init({ duration: 600 });
  };
}

exports.default = Site;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _Separator = __webpack_require__(1);

var _Separator2 = _interopRequireDefault(_Separator);

var _bg = __webpack_require__(4);

var _bg2 = _interopRequireDefault(_bg);

var _logo = __webpack_require__(16);

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hero = function Hero() {
  return (0, _preact.h)(
    'div',
    { style: { position: 'relative' } },
    (0, _preact.h)(_Separator2.default, { upClass: 'neutral', style: { position: 'absolute', 'top': 0, zIndex: 100 } }),
    (0, _preact.h)(
      'section',
      { id: 'hero', className: 'section is-medium is-primary is-bold', style: { backgroundImage: 'url(' + _bg2.default + ')' } },
      (0, _preact.h)(
        'div',
        { className: 'hero-body' },
        (0, _preact.h)(
          'div',
          { className: 'container' },
          (0, _preact.h)(
            'p',
            { className: 'has-text-centered', 'data-aos': 'zoom-out', 'data-aos-delay': '400' },
            (0, _preact.h)('img', { className: 'logo', src: _logo2.default, alt: 'Serverless lab', style: {
                maxWidth: '600px',
                width: '100%'
              } })
          ),
          (0, _preact.h)(
            'p',
            { className: 'main-text has-text-centered is-size-2', 'data-aos': 'zoom-out', 'data-aos-delay': '600' },
            'Effective ',
            (0, _preact.h)(
              'strong',
              null,
              'Serverless'
            ),
            ', ',
            (0, _preact.h)(
              'strong',
              null,
              'AWS Lambda'
            ),
            ' and ',
            (0, _preact.h)(
              'strong',
              null,
              'Node.js'
            ),
            ' training'
          )
        )
      )
    ),
    (0, _preact.h)(_Separator2.default, { downClass: 'neutral', style: { position: 'absolute', 'bottom': 0, zIndex: 100 } })
  );
};

exports.default = Hero;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1be83e8711b7d5f9bccf46f834ba9c68.svg";

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _planetarysystem = __webpack_require__(18);

var _planetarysystem2 = _interopRequireDefault(_planetarysystem);

var _TalkToUsButton = __webpack_require__(6);

var _TalkToUsButton2 = _interopRequireDefault(_TalkToUsButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValueProposition = function ValueProposition() {
  return (0, _preact.h)(
    'div',
    null,
    (0, _preact.h)(
      'section',
      { id: 'value-proposition', className: 'section value-proposition' },
      (0, _preact.h)(
        'div',
        { className: 'container' },
        (0, _preact.h)(
          'div',
          { className: 'content' },
          (0, _preact.h)(
            'h1',
            { 'data-aos': 'fade-up', className: 'title' },
            'Our offer'
          )
        ),
        (0, _preact.h)(
          'div',
          { className: 'columns' },
          (0, _preact.h)(
            'div',
            { className: 'column is-three-quarters', 'data-aos': 'fade-right', 'data-aos-delay': '100' },
            (0, _preact.h)(
              'div',
              { className: 'content' },
              (0, _preact.h)(
                'h2',
                { className: 'is-size-2' },
                'Serverless Lab has designed a training curriculum to get your organisation ready to work with serverless.'
              ),
              (0, _preact.h)(
                'p',
                { className: 'is-size-4 has-text-grey-dark' },
                'Serverless Lab covers topics needed to build enterprise ready applications taking advantage of the Serverless paradigm and the ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'AWS cloud infrastructure'
                ),
                '.',
                (0, _preact.h)('br', null),
                'Our curriculum includes learning ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'Lambda Functions'
                ),
                ', ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'API gateway'
                ),
                ', ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'Dynamo DB'
                ),
                ', ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'S3'
                ),
                ', ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'RDS'
                ),
                ', ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'Cloudwatch'
                ),
                ' and covers from basic to advanced topics like ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'networking'
                ),
                ', ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'performance'
                ),
                ', ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'security'
                ),
                ', ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'troubleshooting'
                ),
                ' and ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'continuous delivery'
                ),
                '.'
              ),
              (0, _preact.h)(
                'p',
                null,
                (0, _preact.h)(_TalkToUsButton2.default, null)
              )
            )
          ),
          (0, _preact.h)(
            'div',
            { className: 'column is-hidden-mobile' },
            (0, _preact.h)(
              'p',
              { className: 'has-text-centered', 'data-aos': 'fade-up' },
              (0, _preact.h)('img', { className: 'section-icon', src: _planetarysystem2.default })
            )
          )
        )
      )
    )
  );
};

exports.default = ValueProposition;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cc64a180e83edbee90e4057adcb1bdb8.svg";

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _Separator = __webpack_require__(1);

var _Separator2 = _interopRequireDefault(_Separator);

var _galaxy = __webpack_require__(20);

var _galaxy2 = _interopRequireDefault(_galaxy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hero = function Hero() {
  return (0, _preact.h)(
    'div',
    null,
    (0, _preact.h)(_Separator2.default, { downClass: 'inverted' }),
    (0, _preact.h)(
      'section',
      { id: 'why-serverless', className: 'section why-serverless bg-inverted' },
      (0, _preact.h)(
        'div',
        { className: 'container' },
        (0, _preact.h)(
          'div',
          { className: 'columns' },
          (0, _preact.h)(
            'div',
            { className: 'column' },
            '\xA0'
          ),
          (0, _preact.h)(
            'div',
            { className: 'column is-three-quarters' },
            (0, _preact.h)(
              'div',
              { className: 'content' },
              (0, _preact.h)(
                'h1',
                { 'data-aos': 'fade-up', className: 'title' },
                'Why is it time to adopt serverless?'
              )
            )
          )
        ),
        (0, _preact.h)(
          'div',
          { className: 'columns' },
          (0, _preact.h)(
            'div',
            { className: 'column is-hidden-mobile' },
            (0, _preact.h)(
              'p',
              { className: 'has-text-centered', 'data-aos': 'fade-up' },
              (0, _preact.h)('img', { className: 'section-icon', src: _galaxy2.default })
            )
          ),
          (0, _preact.h)(
            'div',
            { className: 'column is-three-quarters', 'data-aos': 'fade-left', 'data-aos-delay': '100' },
            (0, _preact.h)(
              'div',
              { className: 'content' },
              (0, _preact.h)(
                'p',
                { className: 'is-size-4' },
                'Serverless lets developers shift their focus from the server level to the task level, allowing organisations to move faster and with greater focus on delivering value to their customers rather than being stuck with infrastructure concerns.'
              ),
              (0, _preact.h)(
                'p',
                { className: 'is-size-5' },
                'If you are a startup or if you are building a new product, serverless will allow you to greatly shorten the time to production and to ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'speed up the development-release-test loop'
                ),
                ' allowing you to ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'find your product-market fit faster'
                ),
                '.'
              ),
              (0, _preact.h)(
                'p',
                { className: 'is-size-5' },
                'If you want to migrate an existing product (or parts of it) to serverless, you will then benefit of ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'greater agility'
                ),
                ' and ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'ability to integrate with other platforms'
                ),
                ' or ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'release new features quickly'
                ),
                ', which will increase your ',
                (0, _preact.h)(
                  'strong',
                  null,
                  'competitive advantage'
                ),
                '.'
              ),
              (0, _preact.h)(
                'p',
                { className: 'is-size-5' },
                'But that\u2019s not all, there are several other important advantages that come with serverless:'
              ),
              (0, _preact.h)(
                'ul',
                { className: 'is-size-6' },
                (0, _preact.h)(
                  'li',
                  null,
                  (0, _preact.h)(
                    'strong',
                    null,
                    'Auto-scalability'
                  ),
                  ': serverless is fully managed. Developers don\u2019t need to implement code to scale and administrators don\u2019t need to worry about updates or provisioning.'
                ),
                (0, _preact.h)(
                  'li',
                  null,
                  (0, _preact.h)(
                    'strong',
                    null,
                    'High availability & Geolocation'
                  ),
                  ': since the infrastructure is fully managed you don\u2019t have to worry about uptime at machinery level, it is guaranteed by the provider. Plus distributing your app over different geographic locations for reduced latency is just  a click away.'
                ),
                (0, _preact.h)(
                  'li',
                  null,
                  (0, _preact.h)(
                    'strong',
                    null,
                    'Efficiency & cost'
                  ),
                  ': Serverless has a \u2018pay per use\u2019 model: you pay for memory allocation and the time spent executing your code, so you don\'t incur the cost of unutilized functions as seen in cloud computing models where even \u2018idle\u2019 resources have to be paid for.'
                )
              )
            )
          )
        )
      )
    ),
    (0, _preact.h)(_Separator2.default, { upClass: 'inverted' })
  );
};

exports.default = Hero;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f0c59b43c1c788af000437830dbea0b9.svg";

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _TabViewer = __webpack_require__(22);

var _TabViewer2 = _interopRequireDefault(_TabViewer);

var _StartupCurriculum = __webpack_require__(23);

var _StartupCurriculum2 = _interopRequireDefault(_StartupCurriculum);

var _AdvancedCurriculum = __webpack_require__(24);

var _AdvancedCurriculum2 = _interopRequireDefault(_AdvancedCurriculum);

var _plantflask = __webpack_require__(25);

var _plantflask2 = _interopRequireDefault(_plantflask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Curricula = function (_Component) {
  _inherits(Curricula, _Component);

  function Curricula(props) {
    _classCallCheck(this, Curricula);

    var _this = _possibleConstructorReturn(this, (Curricula.__proto__ || Object.getPrototypeOf(Curricula)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(Curricula, [{
    key: 'render',
    value: function render() {
      return (0, _preact.h)(
        'section',
        { id: 'curricula', className: 'section curricula' },
        (0, _preact.h)(
          'div',
          { className: 'container' },
          (0, _preact.h)(
            'div',
            { className: 'content' },
            (0, _preact.h)(
              'h1',
              { 'data-aos': 'fade-up', className: 'title' },
              'Curricula'
            )
          ),
          (0, _preact.h)(
            'div',
            { className: 'columns', 'data-aos': 'fade-right', 'data-aos-delay': '100' },
            (0, _preact.h)(
              'div',
              { className: 'column is-three-quarters' },
              (0, _preact.h)(
                'div',
                { className: 'content' },
                (0, _preact.h)(
                  'p',
                  { className: 'is-size-4' },
                  'All our training sessions are focused on learning through building \xA0real enterprise ready applications from scratch.'
                ),
                (0, _preact.h)(
                  'p',
                  { className: 'is-size-5' },
                  'We currently offer two curricula, the ',
                  (0, _preact.h)(
                    'strong',
                    null,
                    'Startup curriculum'
                  ),
                  ', suitable for getting your organisation started very quickly with serverless and the ',
                  (0, _preact.h)(
                    'strong',
                    null,
                    'Advanced curriculum'
                  ),
                  ', focused on improving existing serverless skills and acquiring industry-proven best practices.'
                )
              ),
              (0, _preact.h)(_TabViewer2.default, {
                tabs: ['Startup', 'Advanced'],
                tabsContent: [(0, _preact.h)(_StartupCurriculum2.default, null), (0, _preact.h)(_AdvancedCurriculum2.default, null)]
              })
            ),
            (0, _preact.h)(
              'div',
              { className: 'column is-hidden-mobile' },
              (0, _preact.h)(
                'p',
                { className: 'has-text-centered', 'data-aos': 'fade-up' },
                (0, _preact.h)('img', { className: 'section-icon', src: _plantflask2.default })
              )
            )
          )
        )
      );
    }
  }]);

  return Curricula;
}(_preact.Component);

exports.default = Curricula;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabViewer = function (_Component) {
  _inherits(TabViewer, _Component);

  function TabViewer(props) {
    _classCallCheck(this, TabViewer);

    var _this = _possibleConstructorReturn(this, (TabViewer.__proto__ || Object.getPrototypeOf(TabViewer)).call(this, props));

    _this.state = {
      selected: props.selectedIndex ? parseInt(props.selectedIndex) : 0
    };

    _this._switchTab = _this._switchTab.bind(_this);
    return _this;
  }

  _createClass(TabViewer, [{
    key: '_switchTab',
    value: function _switchTab(e) {
      e.preventDefault();
      this.setState({
        selected: parseInt(e.target.rel)
      });
    }
  }, {
    key: 'render',
    value: function render(_ref) {
      var _this2 = this;

      var tabs = _ref.tabs,
          tabsContent = _ref.tabsContent;

      return (0, _preact.h)(
        'div',
        null,
        (0, _preact.h)(
          'div',
          { className: 'tabs is-medium is-centered is-boxed' },
          (0, _preact.h)(
            'ul',
            null,
            tabs.map(function (tab, index) {
              return (0, _preact.h)(
                'li',
                { key: index, className: _this2.state.selected === index && 'is-active' },
                (0, _preact.h)(
                  'a',
                  { onClick: _this2._switchTab, rel: index, href: '#' },
                  tab
                )
              );
            })
          )
        ),
        (0, _preact.h)(
          'div',
          null,
          tabsContent && tabsContent[this.state.selected]
        )
      );
    }
  }]);

  return TabViewer;
}(_preact.Component);

exports.default = TabViewer;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var StartupCurriculum = function StartupCurriculum() {
  return (0, _preact.h)(
    'div',
    { className: 'content' },
    (0, _preact.h)(
      'p',
      { className: 'is-size-4' },
      'In this curriculum we will build from scratch an ',
      (0, _preact.h)(
        'strong',
        null,
        'application to sell event tickets'
      )
    ),
    (0, _preact.h)(
      'p',
      { className: 'is-size-5' },
      'Class duration: ',
      (0, _preact.h)(
        'strong',
        null,
        '8 hours'
      ),
      ' (1 full day)'
    ),
    (0, _preact.h)(
      'ul',
      { className: 'is-size-6' },
      (0, _preact.h)(
        'li',
        null,
        'What is Serverless and what is AWS Lambda'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Building a real-world serverless application on AWS'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Our first lambda on the AWS console'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Locale development and testing'
      ),
      (0, _preact.h)(
        'li',
        null,
        'SAM template and Cloudformation deployment'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Manage sensible configuration values with Environment Variables'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Building an API to list events'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Introduction to Dynamo DB'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Store events in Dynamo DB'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Use data from Dynamo DB in our event listing API'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Introduction to S3 and CloudFront'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Build a single page serverless application'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Consume our serverless RESTful API from the serverless application'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Create a form to purchase event tickets'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Process the form input with a POST API Lambda Function'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Form validation and errors management'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Introduction to SNS and SQS'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Publishing a message on SQS when a purchase happens'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Creating a worker Lambda to send tickets to the users'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Logging, monitoring and debugging'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Tips and tricks for improved quality and productivity'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Recap & additional learning resources'
      )
    )
  );
};

exports.default = StartupCurriculum;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var AdvancedCurriculum = function AdvancedCurriculum() {
  return (0, _preact.h)(
    'div',
    { className: 'content' },
    (0, _preact.h)(
      'p',
      { className: 'is-size-4' },
      'In this curriculum we improve the application to sell event tickets from the Startup curriculum and make it ',
      (0, _preact.h)(
        'strong',
        null,
        'production-ready'
      )
    ),
    (0, _preact.h)(
      'p',
      { className: 'is-size-5' },
      'Class duration: ',
      (0, _preact.h)(
        'strong',
        null,
        '8 hours'
      ),
      ' (1 full day)'
    ),
    (0, _preact.h)(
      'ul',
      { className: 'is-size-6' },
      (0, _preact.h)(
        'li',
        null,
        'Logging & monitoring with cloudwatch'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Continuous delivery with Circle CI'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Authentication With AUTH0 & JWT'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Authorization'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Organising a complex project with DDD & Microservices'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Design a secure Virtual Private Cloud (VPC) for serverless'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Using serverless with RDS'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Integrate serverless with existing non-serverless applications'
      ),
      (0, _preact.h)(
        'li',
        null,
        'Recap & additional learning resources'
      )
    )
  );
};

exports.default = AdvancedCurriculum;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a0b4963c769c8f33f7beca7820055161.svg";

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Instructors = __webpack_require__(27);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Instructors).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _Separator = __webpack_require__(1);

var _Separator2 = _interopRequireDefault(_Separator);

var _Instructor = __webpack_require__(28);

var _Instructor2 = _interopRequireDefault(_Instructor);

var _data = __webpack_require__(33);

var _data2 = _interopRequireDefault(_data);

var _scientistavatar = __webpack_require__(36);

var _scientistavatar2 = _interopRequireDefault(_scientistavatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Instructors = function Instructors() {
  return (0, _preact.h)(
    'div',
    null,
    (0, _preact.h)(_Separator2.default, { downClass: 'inverted' }),
    (0, _preact.h)(
      'section',
      { id: 'instructors', className: 'section instructors bg-inverted' },
      (0, _preact.h)(
        'div',
        { className: 'container' },
        (0, _preact.h)(
          'div',
          { className: 'columns' },
          (0, _preact.h)(
            'div',
            { className: 'column' },
            '\xA0'
          ),
          (0, _preact.h)(
            'div',
            { className: 'column is-three-quarters' },
            (0, _preact.h)(
              'div',
              { className: 'content' },
              (0, _preact.h)(
                'h1',
                { 'data-aos': 'fade-up', className: 'title' },
                'Our Instructors'
              )
            )
          )
        ),
        (0, _preact.h)(
          'div',
          { className: 'columns' },
          (0, _preact.h)(
            'div',
            { className: 'column is-hidden-mobile' },
            (0, _preact.h)(
              'p',
              { className: 'has-text-centered', 'data-aos': 'fade-up' },
              (0, _preact.h)('img', { className: 'section-icon', src: _scientistavatar2.default })
            )
          ),
          (0, _preact.h)(
            'div',
            { className: 'column is-three-quarters', 'data-aos': 'fade-left', 'data-aos-delay': '100' },
            (0, _preact.h)(
              'div',
              { className: 'content' },
              (0, _preact.h)(
                'p',
                { className: 'is-size-5' },
                'Our instructors have proven serverless experience in serverless \xA0building complex enterprise applications and delivering workshops \xA0and talks in some of the most famous conferences around the globe.'
              )
            ),
            (0, _preact.h)(
              'div',
              { className: 'columns is-centered' },
              _data2.default.map(function (instructor, i) {
                return (0, _preact.h)(
                  'div',
                  { key: i, className: 'column is-half' },
                  (0, _preact.h)(_Instructor2.default, _extends({}, instructor, { direction: i % 2 === 0 ? 'left' : 'right' }))
                );
              })
            )
          )
        )
      )
    ),
    (0, _preact.h)(_Separator2.default, { upClass: 'inverted' })
  );
};

exports.default = Instructors;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _website = __webpack_require__(29);

var _website2 = _interopRequireDefault(_website);

var _twitter = __webpack_require__(30);

var _twitter2 = _interopRequireDefault(_twitter);

var _github = __webpack_require__(31);

var _github2 = _interopRequireDefault(_github);

var _linkedin = __webpack_require__(32);

var _linkedin2 = _interopRequireDefault(_linkedin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstructorMedia = function InstructorMedia(_ref) {
  var picture = _ref.picture,
      name = _ref.name,
      index = _ref.index,
      direction = _ref.direction;

  if (direction === 'left' && index % 2) {
    return '';
  }

  return (0, _preact.h)(
    'figure',
    { className: 'media-' + direction },
    (0, _preact.h)(
      'p',
      { className: 'image is-64x64 avatar' },
      (0, _preact.h)('img', { src: picture, alt: name + '\'s profile picture\'' })
    )
  );
};

var Instructor = function Instructor(_ref2) {
  var name = _ref2.name,
      picture = _ref2.picture,
      description = _ref2.description,
      links = _ref2.links,
      direction = _ref2.direction;
  return (0, _preact.h)(
    'div',
    { className: 'box', 'data-aos-delay': '200', 'data-aos': 'fade-' + (direction === 'left' ? 'right' : 'left') },
    (0, _preact.h)(
      'div',
      { className: 'media' },
      direction === 'left' && (0, _preact.h)(InstructorMedia, { name: name, picture: picture, direction: direction }),
      (0, _preact.h)(
        'div',
        { className: 'media-content' },
        (0, _preact.h)(
          'div',
          { className: 'content', style: { textAlign: direction } },
          (0, _preact.h)(
            'h3',
            { className: 'is-size-4' },
            name
          ),
          (0, _preact.h)(
            'p',
            null,
            (0, _preact.h)(
              'a',
              { title: 'Website', href: links.website, target: '_blank' },
              (0, _preact.h)('img', { alt: 'Website', src: _website2.default, style: { width: '1em', height: '1em' } })
            ),
            '\xA0',
            (0, _preact.h)(
              'a',
              { title: 'Twitter', href: links.twitter, target: '_blank' },
              (0, _preact.h)('img', { alt: 'Twitter', src: _twitter2.default, style: { width: '1em', height: '1em' } })
            ),
            '\xA0',
            (0, _preact.h)(
              'a',
              { title: 'GitHub', href: links.github, target: '_blank' },
              (0, _preact.h)('img', { alt: 'GitHub', src: _github2.default, style: { width: '1em', height: '1em' } })
            ),
            '\xA0',
            (0, _preact.h)(
              'a',
              { title: 'LinkedIn', href: links.linkedin, target: '_blank' },
              (0, _preact.h)('img', { alt: 'LinkedIn', src: _linkedin2.default, style: { width: '1em', height: '1em' } })
            )
          )
        )
      ),
      direction === 'right' && (0, _preact.h)(InstructorMedia, { name: name, picture: picture, direction: direction })
    ),
    (0, _preact.h)(
      'section',
      { className: 'section' },
      (0, _preact.h)(
        'div',
        { className: 'content' },
        (0, _preact.h)(
          'p',
          { className: 'is-size-6' },
          description
        )
      )
    )
  );
};

exports.default = Instructor;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1f5425c3beaeb1e65a5f2107328dbb90.svg";

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "61de6e3476f171e0075e47bfce5d51e0.svg";

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ff66eb8ec531024561b1c1ddab593e2f.svg";

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6713d665dc58cf4b495368a7871c133d.svg";

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lucianoMammino = __webpack_require__(34);

var _lucianoMammino2 = _interopRequireDefault(_lucianoMammino);

var _padraigOBrien = __webpack_require__(35);

var _padraigOBrien2 = _interopRequireDefault(_padraigOBrien);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var data = [{
  name: 'Padraig O\'Brien',
  picture: _padraigOBrien2.default,
  description: 'Padraig has been working in IT for nearly 20 years, covering all areas from engineering, product development, testing, operations and senior management. He is the organiser of Serverless Dublin, Lean Coffee Dublin and Nodeschool dublin. He is currently working on unicorndb.io',
  links: {
    website: 'https://padraigobrien.com/',
    twitter: 'https://twitter.com/Podgeypoos79',
    github: 'https://github.com/padraigobrien',
    linkedin: 'https://www.linkedin.com/in/padraigobrien'
  }
}, {
  name: 'Luciano Mammino',
  picture: _lucianoMammino2.default,
  description: 'Luciano is a passionate fullstack software developer, Node.js and JavaScript believer and co-author of "Node.js design patterns" (Packt). He Recently launched Fullstack Bulletin, a semi-automated weekly newsletter, completely open source and built on top of serverless services.',
  links: {
    website: 'https://loiege.co/',
    twitter: 'https://twitter.com/loige',
    github: 'https://github.com/lmammino',
    linkedin: 'https://www.linkedin.com/in/lucianomammino'
  }
}];

exports.default = data;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7afb1b3be2c8eefe316c73e7c3a495d1.jpg";

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "751c787cfdacb0040076d57b727380f6.jpg";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "acfb7a4e7ea8900eca4fa81590cd1a69.svg";

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _TalkToUsButton = __webpack_require__(6);

var _TalkToUsButton2 = _interopRequireDefault(_TalkToUsButton);

var _flagstarplanet = __webpack_require__(38);

var _flagstarplanet2 = _interopRequireDefault(_flagstarplanet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WhyTraining = function (_Component) {
  _inherits(WhyTraining, _Component);

  function WhyTraining(props) {
    _classCallCheck(this, WhyTraining);

    var _this = _possibleConstructorReturn(this, (WhyTraining.__proto__ || Object.getPrototypeOf(WhyTraining)).call(this, props));

    _this.state = {
      days: '2',
      engineers: '20',
      efficiency: '1'
    };

    _this._changeDays = _this._changeDays.bind(_this);
    _this._changeEngineers = _this._changeEngineers.bind(_this);
    _this._changeEfficiency = _this._changeEfficiency.bind(_this);
    return _this;
  }

  _createClass(WhyTraining, [{
    key: '_changeDays',
    value: function _changeDays(e) {
      e.preventDefault();
      this.setState({ days: e.target.value });
    }
  }, {
    key: '_changeEngineers',
    value: function _changeEngineers(e) {
      this.setState({ engineers: e.target.value });
    }
  }, {
    key: '_changeEfficiency',
    value: function _changeEfficiency(e) {
      this.setState({ efficiency: e.target.value });
    }
  }, {
    key: 'render',
    value: function render() {
      var totWorkingHours = 250 * 8 * parseFloat(this.state.engineers);
      var improvement = parseFloat(this.state.days) * parseFloat(this.state.efficiency) / parseFloat(100);
      var hoursForTraining = 8 * parseFloat(this.state.days) * parseFloat(this.state.engineers);
      var roi = Math.round(totWorkingHours * improvement - hoursForTraining);

      return (0, _preact.h)(
        'section',
        { id: 'why-training', className: 'section why-training' },
        (0, _preact.h)(
          'div',
          { className: 'container' },
          (0, _preact.h)(
            'div',
            { className: 'content' },
            (0, _preact.h)(
              'h1',
              { 'data-aos': 'fade-up', className: 'title' },
              'Why choose in-house training'
            )
          ),
          (0, _preact.h)(
            'div',
            { className: 'columns' },
            (0, _preact.h)(
              'div',
              { className: 'column is-three-quarters', 'data-aos': 'fade-right', 'data-aos-delay': '100' },
              (0, _preact.h)(
                'div',
                { className: 'content' },
                (0, _preact.h)(
                  'h2',
                  { className: 'is-size-2' },
                  'Invest in training and save valuable hours of work'
                ),
                (0, _preact.h)(
                  'p',
                  { className: 'is-size-4 has-text-grey-dark' },
                  'We believe that in house training will improve the performance of your team, making it more efficient and making your organisation save valuable working hours. Hours that you can invest in making your company even more successful.'
                ),
                (0, _preact.h)(
                  'div',
                  { className: 'box' },
                  (0, _preact.h)(
                    'h3',
                    null,
                    'Auto-magic Training ROI calculator\u2122'
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'columns' },
                    (0, _preact.h)(
                      'div',
                      { className: 'column is-half' },
                      (0, _preact.h)(
                        'div',
                        { className: 'content' },
                        (0, _preact.h)(
                          'div',
                          { className: 'field' },
                          (0, _preact.h)(
                            'label',
                            { className: 'label' },
                            'Days of training'
                          ),
                          (0, _preact.h)(
                            'div',
                            { className: 'control' },
                            (0, _preact.h)(
                              'radiogroup',
                              { name: 'days' },
                              (0, _preact.h)(
                                'label',
                                { className: 'radio is-medium' },
                                (0, _preact.h)('input', { onChange: this._changeDays, className: 'radio is-medium', type: 'radio', name: 'days', value: '1', checked: parseFloat(this.state.days) === 1 }),
                                ' 1 day'
                              ),
                              (0, _preact.h)(
                                'label',
                                { className: 'radio is-medium' },
                                (0, _preact.h)('input', { onChange: this._changeDays, className: 'radio is-medium', type: 'radio', name: 'days', value: '2', checked: parseFloat(this.state.days) === 2 }),
                                ' 2 days'
                              )
                            )
                          )
                        ),
                        (0, _preact.h)(
                          'div',
                          { className: 'field' },
                          (0, _preact.h)(
                            'label',
                            { className: 'label' },
                            'Engineers'
                          ),
                          (0, _preact.h)(
                            'div',
                            { className: 'control' },
                            (0, _preact.h)('input', { onChange: this._changeEngineers, type: 'number', min: '10', max: '50', className: 'input is-medium', value: this.state.engineers })
                          )
                        ),
                        (0, _preact.h)(
                          'div',
                          { className: 'field' },
                          (0, _preact.h)(
                            'label',
                            { className: 'label' },
                            'Expected performance improvement (',
                            this.state.efficiency,
                            '%)'
                          ),
                          (0, _preact.h)(
                            'div',
                            { className: 'control' },
                            (0, _preact.h)('input', { onChange: this._changeEfficiency, type: 'range', min: '1', max: '5', className: 'range is-medium', value: this.state.efficiency })
                          )
                        )
                      )
                    ),
                    (0, _preact.h)(
                      'div',
                      { className: 'column is-half' },
                      (0, _preact.h)(
                        'div',
                        { className: 'message is-success' },
                        (0, _preact.h)(
                          'div',
                          { className: 'message-body' },
                          (0, _preact.h)(
                            'p',
                            { className: 'has-text-centered' },
                            (0, _preact.h)(
                              'strong',
                              { className: 'is-size-2' },
                              roi
                            ),
                            (0, _preact.h)('br', null),
                            (0, _preact.h)(
                              'span',
                              { className: 'is-size-5' },
                              'Hours of work saved in 1 year'
                            )
                          )
                        )
                      )
                    )
                  )
                ),
                (0, _preact.h)(
                  'p',
                  null,
                  (0, _preact.h)(_TalkToUsButton2.default, null)
                )
              )
            ),
            (0, _preact.h)(
              'div',
              { className: 'column is-hidden-mobile' },
              (0, _preact.h)(
                'p',
                { className: 'has-text-centered', 'data-aos': 'fade-up' },
                (0, _preact.h)('img', { className: 'section-icon', src: _flagstarplanet2.default })
              )
            )
          )
        )
      );
    }
  }]);

  return WhyTraining;
}(_preact.Component);

exports.default = WhyTraining;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "854881a2a2038a4bb6d75e54f34dbee9.svg";

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _Separator = __webpack_require__(1);

var _Separator2 = _interopRequireDefault(_Separator);

var _bg = __webpack_require__(4);

var _bg2 = _interopRequireDefault(_bg);

var _TalkToUsButton = __webpack_require__(6);

var _TalkToUsButton2 = _interopRequireDefault(_TalkToUsButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Closing = function Closing() {
  return (0, _preact.h)(
    'div',
    { style: { position: 'relative' } },
    (0, _preact.h)(_Separator2.default, { upClass: 'neutral', style: { position: 'absolute', 'top': 0, zIndex: 100 } }),
    (0, _preact.h)(
      'section',
      { id: 'hero', className: 'notfound section is-medium is-primary is-bold', style: { backgroundImage: 'url(' + _bg2.default + ')' } },
      (0, _preact.h)(
        'div',
        { className: 'hero-body' },
        (0, _preact.h)(
          'div',
          { className: 'container' },
          (0, _preact.h)(
            'p',
            { className: 'main-text closing has-text-centered is-size-1', 'data-aos': 'zoom-out', 'data-aos-delay': '300' },
            'Learn Serverless today'
          ),
          (0, _preact.h)(
            'p',
            { className: 'has-text-centered is-size-3' },
            (0, _preact.h)(_TalkToUsButton2.default, { label: 'Talk to us' })
          )
        )
      )
    )
  );
};

exports.default = Closing;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// site-1.0.16.js